<template>
  <div class="" v-if="dataLoaded">
    <div class="overview-bg" v-if="!showPackageInfo">
      <div style="width: 100%">
        <div style="width: 100%">
          <p class="get-started text--warining">Get Started</p>
        </div>
        <div style="width: 100%">
          <p class="overview-subtitle">
            by creating and publishing your first campaign
          </p>
        </div>
        <div style="width: 100%">
          <p class="overview-steps-header">The journey begins here:</p>
          <p class="overview-step">1- Add WhatsApp number</p>
          <p class="overview-step">2- Get your template message approved</p>
          <p class="overview-step">3- Create and publish your campaign</p>
        </div>
        <v-btn
          v-model="fab"
          color="primary"
          dark
          to="/campaigns/whatsapp-apps?cb=add"
        >
          Get Started
        </v-btn>
      </div>

      <!-- <div>
        <campaign-package
          :campaignManagerConfig="account.campaign_manager_config"
          @error="handleError"
        />
      </div> -->
    </div>

    <div v-else>
      <!-- <campaign-package
        :campaignManagerConfig="account.campaign_manager_config"
        @error="handleError"
      /> -->
      <campaigns-overview @error="handleError" />
    </div>
  </div>
</template>

<script>
// import CampaignOverview from "../campaign-overview/campaignOverview.vue";
// import campaignPackage from "./insights/campaignPackage";
import campaignsOverview from "./insights/campaignsOverview";
export default {
  name: "overview",
  data() {
    return {
      fab: "",
      account: [],
      dataLoaded: true,
      hasErrors: false,
    };
  },
  components: {
    // campaignPackage,
    campaignsOverview,
  },
  mounted() {
    // this.getAccountDetails();
  },
  computed: {
    showPackageInfo() {
      // console.log(`ACCOUNT ${this.account.campaign_manager_config.active}`);
      // return this.account && this.account.campaign_manager_config;
      return true;
    },
  },
  methods: {
    async getAccountDetails() {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_session_manager.get(
        `bots/${this.$store.state.bot.botId}/account`
      );

      this.dataLoaded = true;
      this.account = response.data;
    },
    handleError() {
      this.hasErrors = true;
    },
  },
};
</script>

<style lang="css" scoped>
.overview-bg {
  background: url(../../../assets/img/campaign-overview.png);
  width: calc(85vw - 82px);
  height: calc(100vh - 70px);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 1;
  display: flex;
  align-content: center;
  padding: 50px;
}
.get-started {
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 0.36px;
  text-align: left;
}
.overview-subtitle {
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.07;
  letter-spacing: 0.34px;
  text-align: left;
  color: #3966ff;
}
.overview-steps-header {
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: 0.23px;
  text-align: left;
  color: #000000;
}
.overview-step {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.94;
  letter-spacing: 0.18px;
  text-align: left;
  color: #000000;
}
.campaigns-overview-actions {
  margin-left: 0;
  border-radius: 50% !important;
  height: 40px !important;
  width: 40px !important;
  min-width: 40px !important;
  max-width: 40px !important;
  padding: 0;
}
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>
